
import { useState } from 'react';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import MapSection from './components/MapSection';
import WhatsAppButton from './components/WhatsAppButton';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <ContactHero />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <ContactForm />
          <div className="space-y-8">
            <ContactInfo />
            <MapSection />
          </div>
        </div>
      </div>
      
      <WhatsAppButton />
    </div>
  );
};

export default ContactPage;
